
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export function ValuePropositionSection() {
  return (
    <motion.div 
      className="action-card overflow-hidden bg-gradient-to-br from-background to-gold/5 dark:from-background dark:to-gold/10 h-full"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.7 }}
      whileHover={{ y: -5 }}
    >
      <div className="h-full flex flex-col justify-between p-6">
        <div>
          <h2 className="text-2xl font-bold mb-4 text-gold">
            Vuoi Valutare il Tuo Oro?
          </h2>
          <p className="mb-6 text-foreground/80">
            Confronta le valutazioni di diversi compro oro nella tua zona e ottieni il miglior prezzo per i tuoi preziosi. La nostra rete di partner verificati garantisce sempre la massima trasparenza.
          </p>
        </div>
        <Button className="bg-gold text-white hover:bg-gold-dark hover:scale-105 transition-transform font-medium w-full" asChild>
          <Link to="/compro-oro" className="flex items-center justify-center">
            Trova il Miglior Compro Oro <ArrowUpRight className="ml-2" />
          </Link>
        </Button>
      </div>
    </motion.div>
  );
}
